import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { AuthService } from 'src/app/services/auth.service';
import { MessageService } from 'primeng/api';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { catchError } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';
import { EMPTY } from 'rxjs';
import { InstagramOauthResponse } from 'src/app/services/product.service';

@Component({
  selector: 'app-instagram-auth',
  templateUrl: './instagram-auth.component.html',
  styleUrls: ['./instagram-auth.component.scss'],
  providers: [MessageService]
})
export class InstagramAuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private instagramData: InstagramOauthResponse | null = null;
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private errorHandler: ErrorHandlerService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 1200);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      const code = params['code'];
      const state = params['state'];
      const error = params['error'];

      if (state) {
        try {
          const stateObj = JSON.parse(atob(state));
          this.selectedStoreId = stateObj.selectedStoreId || '';
          if (this.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);
          if (stateObj.accessToken) localStorage.setItem('access_token', stateObj.accessToken);
        } catch (e) {
          console.warn('State inválido', e);
        }
      }

      if (!this.selectedStoreId) {
        this.selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      }

      if (error) {
        this.showError('Autorização negada pelo usuário.');
        return;
      }

      if (code && state) this.finishInstagramLogin(code, state);
    });
  }

  private finishInstagramLogin(code: string, state: string) {
    this.productService.instagramOauth(code, state).pipe(
      catchError((error) => {
        this.showError('Não foi possível autenticar no Instagram.');
        return EMPTY;
      })
    ).subscribe(data => {
      this.instagramData = data;
      this.autoIntegrate();
    });
  }

  private autoIntegrate() {
    if (!this.selectedStoreId || !this.instagramData) {
      this.showError('Loja não identificada. Tente novamente.');
      return;
    }

    localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);

    const payload = {
      access_token: this.instagramData.access_token,
      instagram_user_id: this.instagramData.user_id,
      expires_in: this.instagramData.expires_in,
      status: 'active',
      form_value: {
        name: this.instagramData.name,
        picture: this.instagramData.picture
      }
    };

    this.productService.createAppsStore2('instagram', payload).pipe(
      catchError((err) => {
        this.showError('Não foi possível salvar integração.');
        return EMPTY;
      })
    ).subscribe(() => {
      this.loading = false;
      // const isAndroid = /android/i.test(navigator.userAgent);
      // if (isAndroid) {
      //   window.location.href = 'myslick://auth/instagram?result=success';
      //   return;
      // }
      try {
        const channel = new BroadcastChannel('oauth-channel');
        channel.postMessage({ type: 'instagram-connected' });
        channel.close();
      } catch {}
      try { window.close(); } catch {}
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => { try { window.close(); } catch {} }, 3000);
  }
}
